import { render, staticRenderFns } from "./AccessManager.vue?vue&type=template&id=d1bb714a"
import script from "./AccessManager.vue?vue&type=script&lang=js"
export * from "./AccessManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/maq/Code/skyier/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d1bb714a')) {
      api.createRecord('d1bb714a', component.options)
    } else {
      api.reload('d1bb714a', component.options)
    }
    module.hot.accept("./AccessManager.vue?vue&type=template&id=d1bb714a", function () {
      api.rerender('d1bb714a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/web-components/AccessManager.vue"
export default component.exports